import React from "react";
import InputField from "../../SharedComponent/Fields/InputField";
import { useTranslation } from "react-i18next";
import SelectField from "../../SharedComponent/Fields/SelectField";
import TextAreaFielD from "../../SharedComponent/Fields/TextareaField";
import { ImagePlus, Upload, X } from "lucide-react";
import { getAttachmentLargeUrl, getAttachmentThumbUrl, getAttachmentDocumentUrl } from "../../utils/attachmentImages";

const Attachments = ({
  formatAttachment,
  handleDeleteAttachment,
  assetAttachments,
  newAsset,
  handleChange,
  warehouses,
  selectedWarehouse,
  handleWarehouseChange,
  warehouseLocationId,
  selectedFiles,
  handleRemoveFile,
  handleFileChange,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="bg-white p-4 shadow-md">
        <h2 className="text-xl font-medium mb-3 text-gray-800">
          {t("assetPageHeadings.basics")}
        </h2>

        {/* Row 1: Classification, Manufacturer, Type, Serial No */}
        <div className="grid grid-cols-1 sm:grid-cols-4 gap-2">
          <SelectField
            name="attachment_toc"
            value={newAsset.attachment_toc}
            onChange={handleChange}
            required
            label={t("assets.fields.classification")}
            explanation={t("assets.fields.explanation.classification")}
            placeholder={t("assets.fields.selectClassification")}
            menus={[
              { value: "", option: t("assets.fields.selectClassification") },
              { value: 1, option: t("attachments.types.loadPushUnit") },
              { value: 2, option: t("attachments.types.baleClamps") },
              { value: 3, option: t("attachments.types.baleClamps360") },
              { value: 4, option: t("attachments.types.pulpBaleClamps360") },
              { value: 5, option: t("attachments.types.boxDischargeUnit") },
              {
                value: 6,
                option: t("attachments.types.multiPalletHandlerProfile"),
              },
              { value: 7, option: t("attachments.types.poleTineClamps") },
              { value: 8, option: t("attachments.types.twoWayForkClamps") },
              { value: 9, option: t("attachments.types.twoWayForkClamps360") },
              { value: 10, option: t("attachments.types.rotators360") },
              { value: 11, option: t("attachments.types.rotators360BoltOn") },
              { value: 12, option: t("attachments.types.dischargeUnit") },
              { value: 13, option: t("attachments.types.rotatingJawClamps") },
              { value: 14, option: t("attachments.types.drumClamps") },
              { value: 15, option: t("attachments.types.drumClamps360") },
              { value: 16, option: t("attachments.types.harbourClamps") },
              {
                value: 17,
                option: t("attachments.types.applianceClampsCirculating"),
              },
              {
                value: 18,
                option: t("attachments.types.applianceClampsRigid"),
              },
              { value: 19, option: t("attachments.types.forkClamps") },
              { value: 20, option: t("attachments.types.forkClamps360") },
              { value: 21, option: t("attachments.types.loadPushPulls") },
              { value: 22, option: t("attachments.types.jibCrane") },
              { value: 23, option: t("attachments.types.loadStabilizers") },
              {
                value: 24,
                option: t("attachments.types.multiPalletHandlers21"),
              },
              {
                value: 25,
                option: t("attachments.types.palletHandlersLoadExtender"),
              },
              {
                value: 26,
                option: t("attachments.types.multiPalletHandlerProfile"),
              },
              {
                value: 27,
                option: t("attachments.types.multiPalletHandlers321"),
              },
              {
                value: 28,
                option: t("attachments.types.multiPalletHandlers4"),
              },
              {
                value: 29,
                option: t("attachments.types.multiPalletHandlers42"),
              },
              {
                value: 30,
                option: t("attachments.types.multiPalletHandlers64"),
              },
              { value: 31, option: t("attachments.types.palletInverters360") },
              { value: 32, option: t("attachments.types.loadExtenders") },
              { value: 33, option: t("attachments.types.paperRollClamps360") },
              { value: 34, option: t("attachments.types.paperRollClamps180") },
              {
                value: 35,
                option: t("attachments.types.paperRollClamps360Arm"),
              },
              {
                value: 36,
                option: t("attachments.types.paperRollClamps180Arm"),
              },
              { value: 37, option: t("attachments.types.rollUpender90") },
              {
                value: 38,
                option: t("attachments.types.rollUpender90With360"),
              },
              { value: 39, option: t("attachments.types.tyreClamps360") },
              { value: 40, option: t("attachments.types.foamClamps") },
              {
                value: 41,
                option: t("attachments.types.hoseReelsSupportFlex"),
              },
              { value: 42, option: t("attachments.types.hydraulicScoops") },
              { value: 43, option: t("attachments.types.sideshifts") },
              { value: 44, option: t("attachments.types.sideshiftsDual") },
              { value: 45, option: t("attachments.types.sideshiftsTriple") },
              {
                value: 46,
                option: t("attachments.types.trilateralHeadsShaft"),
              },
              { value: 47, option: t("attachments.types.trilateralHeadsRack") },
              { value: 48, option: t("attachments.types.brickBlockClamps") },
              { value: 49, option: t("attachments.types.tobaccoClamps") },
              { value: 50, option: t("attachments.types.tissueRollClamps360") },
              { value: 51, option: t("attachments.types.carpetBoom") },
              { value: 52, option: t("attachments.types.loadExtenders") },
              { value: 53, option: t("attachments.types.pulpBaleClampsRigid") },
              {
                value: 54,
                option: t("attachments.types.pulpBaleClampsArticulating"),
              },
              { value: 55, option: t("attachments.types.forkPositioners360") },
              {
                value: 56,
                option: t("attachments.types.forkPositionersProfile"),
              },
              {
                value: 57,
                option: t("attachments.types.forkPositionersShaft"),
              },
              { value: 58, option: t("attachments.types.other") },
              { value: 59, option: t("attachments.types.snowPusher") },
              { value: 60, option: t("attachments.types.roundTimberGripper") },
              { value: 61, option: t("attachments.types.forkPositioners") },
              {
                value: 62,
                option: t("attachments.types.tineAdjustmentSideshift"),
              },
              { value: 63, option: t("attachments.types.pushOutForks") },
              { value: 64, option: t("attachments.types.baleTongsSideshift") },
              { value: 65, option: t("attachments.types.reelClampSwivelling") },
              {
                value: 66,
                option: t("attachments.types.tiltingDeviceShovels"),
              },
              {
                value: 67,
                option: t("attachments.types.doubleReelTurningClamping"),
              },
              { value: 68, option: t("attachments.types.attachmentClamp") },
              { value: 69, option: t("attachments.types.hydraulicRopeHoist") },
              { value: 70, option: t("attachments.types.telescopeForkTine") },
              { value: 71, option: t("attachments.types.accessories") },
              { value: 72, option: t("attachments.types.forks") },
              { value: 73, option: t("attachments.types.barrelLifter") },
              { value: 74, option: t("attachments.types.loadGuardGrill") },
              { value: 75, option: t("attachments.types.personsBasket") },
              { value: 76, option: t("attachments.types.telescopicCrane") },
              { value: 77, option: t("attachments.types.forkExtension") },
              { value: 78, option: t("attachments.types.pouchLifter") },
              { value: 79, option: t("attachments.types.sweepingMachine") },
              { value: 80, option: t("attachments.types.pipeClamp") },
              { value: 81, option: t("attachments.types.clampCementPipes") },
              { value: 82, option: t("attachments.types.containerSpreader") },
              { value: 83, option: t("attachments.types.piggybackSpreader") },
              { value: 84, option: t("attachments.types.liftTruckScales") },
            ]}
            selectClassName={
    !newAsset.attachment_toc
      ? "text-gray-400 font-light"
      : "text-gray-900 font-normal"
  }
          />

          <InputField
            required
            name="manufacturer"
            value={newAsset.manufacturer}
            maxLength={100}
            onChange={handleChange}
            label={t("assets.fields.manufacturer")}
            explanation={t("assets.fields.explanation.manufacturer")}
            placeholder={t("createAsset.placeholder.enterManufacturer")}
          />

          <InputField
            name="type"
            value={newAsset.type}
            onChange={handleChange}
            label={t("assets.fields.type")}
            placeholder={t("createAsset.placeholder.enterType")}
            explanation={t("assets.fields.explanation.type")}
            maxLength={30}
          />

          <InputField
            name="serial_no"
            value={newAsset.serial_no}
            onChange={handleChange}
            placeholder={t("createAsset.placeholder.enterSerialNumber")}
            explanation={t("assets.fields.serialNumber")}
            label={t("assets.fields.machineSerialNo")}
            maxLength={100}
          />
        </div>

        {/* Row 2: Intern No, Status, ISO-Class, Year */}
        <div className="grid grid-cols-1 sm:grid-cols-4 gap-2 mt-2">
          <InputField
            name="attachment_internalno"
            value={newAsset.attachment_internalno}
            onChange={handleChange}
            maxLength={100}
            label={t("createAsset.placeholders.internNoLabel")}
            explanation={t("createAsset.placeholders.internNoExplanation")}
            placeholder={t("createAsset.placeholders.internNoPlaceholder")}
          />

          <SelectField
            name="status"
            value={newAsset.status}
            onChange={handleChange}
            label={t("assets.fields.status")}
            explanation={t("assets.fields.explanation.status")}
            placeholder={t("createAsset.placeholder.enterStatus")}
            menus={[
              { value: "", option: t("assets.fields.selectStatus") },
              { value: "New", option: t("assets.options.new") },
              { value: "Used", option: t("assets.options.used") },
              { value: "Demo", option: t("assets.options.demo") },
            ]}
          />

          <InputField
            name="attachment_isoclass"
            value={newAsset.attachment_isoclass}
            onChange={handleChange}
            label={t("attachments.fields.isoclass")}
            placeholder={t("attachments.placeholders.enterIsoClass")}
            explanation={t("attachments.explanations.isoclass")}
            maxLength={20}
          />

          <InputField
            name="year_of_manufacture"
            type="year"
            value={newAsset.year_of_manufacture}
            onChange={handleChange}
            label={t("assets.fields.yearOfManufacture")}
            explanation={t("assets.fields.explanation.yearOfManufacture")}
            placeholder={t("createAsset.placeholder.enterYearOfManufacture")}
          />
        </div>

        {/* Row 3: Specs */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mt-2">
          <InputField
            name="capacity"
            type="number"
            value={newAsset.capacity}
            onChange={handleChange}
            label={t("attachments.fields.capacity")}
            explanation={t("attachments.explanations.capacity")}
            placeholder={t("attachments.placeholders.capacity")}
          />
          <InputField
            name="attachment_rangefrom"
            type="number"
            value={newAsset.attachment_rangefrom}
            onChange={handleChange}
            label={t("attachments.fields.openingRangeFrom")}
            explanation={t("attachments.explanations.openingRangeFrom")}
            placeholder={t("attachments.placeholders.openingRangeFrom")}
          />
          <InputField
            name="attachment_rangeto"
            type="number"
            value={newAsset.attachment_rangeto}
            onChange={handleChange}
            label={t("attachments.fields.openingRangeTo")}
            explanation={t("attachments.explanations.openingRangeTo")}
            placeholder={t("attachments.placeholders.openingRangeTo")}
          />
          <InputField
            name="attachment_loadcenter"
            type="number"
            value={newAsset.attachment_loadcenter}
            onChange={handleChange}
            label={t("attachments.fields.loadCentre")}
            explanation={t("attachments.explanations.loadCentre")}
            placeholder={t("attachments.placeholders.loadCentre")}
          />
          <InputField
            name="attachment_center_gravity"
            type="number"
            value={newAsset.attachment_center_gravity}
            onChange={handleChange}
            label={t("attachments.fields.centreOfGravity")}
            explanation={t("attachments.explanations.centreOfGravity")}
            placeholder={t("attachments.placeholders.centreOfGravity")}
          />
          <InputField
            name="attachmemt_lost_load_center"
            type="number"
            value={newAsset.attachmemt_lost_load_center}
            onChange={handleChange}
            label={t("attachments.fields.lostLoadCentre")}
            explanation={t("attachments.explanations.lostLoadCentre")}
            placeholder={t("attachments.placeholders.lostLoadCentre")}
          />
          <InputField
            name="attachment_fork_weight"
            type="number"
            value={newAsset.attachment_fork_weight}
            onChange={handleChange}
            label={t("attachments.fields.weight")}
            explanation={t("attachments.explanations.weight")}
            placeholder={t("attachments.placeholders.weight")}
          />
          <InputField
            name="attachment_overall_width"
            type="number"
            value={newAsset.attachment_overall_width}
            onChange={handleChange}
            label={t("attachments.fields.overallWidth")}
            explanation={t("attachments.explanations.overallWidth")}
            placeholder={t("attachments.placeholders.overallWidth")}
          />
          <InputField
            name="attachment_back_width"
            type="number"
            value={newAsset.attachment_back_width}
            onChange={handleChange}
            label={t("attachments.fields.backWidth")}
            explanation={t("attachments.explanations.backWidth")}
            placeholder={t("attachments.placeholders.backWidth")}
          />
          <InputField
            name="attachment_fork_length"
            type="number"
            value={newAsset.attachment_fork_length}
            onChange={handleChange}
            label={t("attachments.fields.forkLength")}
            explanation={t("attachments.explanations.forkLength")}
            placeholder={t("attachments.placeholders.forkLength")}
          />
          <InputField
            name="attachment_fork_width"
            type="number"
            value={newAsset.attachment_fork_width}
            onChange={handleChange}
            label={t("attachments.fields.forkWidth")}
            explanation={t("attachments.explanations.forkWidth")}
            placeholder={t("attachments.placeholders.forkWidth")}
          />
          <InputField
            name="attachment_fork_thickness"
            type="number"
            value={newAsset.attachment_fork_thickness}
            onChange={handleChange}
            label={t("attachments.fields.forkThickness")}
            explanation={t("attachments.explanations.forkThickness")}
            placeholder={t("attachments.placeholders.forkThickness")}
          />
        </div>

        {/* Row 4: Condition, Commission, Available From */}
        <div className="grid grid-cols-1 sm:grid-cols-4 gap-2 mt-2">
          <SelectField
            name="technical_condition"
            value={newAsset.technical_condition}
            onChange={handleChange}
            label={t("createAsset.placeholders.technicalConditionLabel")}
            explanation={t(
              "createAsset.placeholders.technicalConditionExplanation"
            )}
            placeholder={t(
              "createAsset.placeholders.technicalConditionPlaceholder"
            )}
            menus={[
              {
                value: "",
                option: t(
                  "createAsset.placeholders.technicalConditionPlaceholder"
                ),
              },
              {
                value: 2,
                option: t("assets.technicalCondition.very_good"),
              },
              {
                value: 3,
                option: t("assets.technicalCondition.good"),
              },
              {
                value: 4,
                option: t("assets.technicalCondition.used"),
              },
              {
                value: 5,
                option: t("assets.technicalCondition.bad"),
              },
              {
                value: 6,
                option: t("assets.technicalCondition.very_bad"),
              },
              {
                value: 7,
                option: t("assets.technicalCondition.new"),
              },
            ]}
          />
          {/* <div className="flex-1 col-span-2"> */}
          <SelectField
            name="optical_condition"
            value={newAsset.optical_condition}
            onChange={handleChange}
            label={t("createAsset.placeholders.opticalConditionLabel")}
            explanation={t(
              "createAsset.placeholders.opticalConditionExplanation"
            )}
            placeholder={t(
              "createAsset.placeholders.opticalConditionPlaceholder"
            )}
            menus={[
              {
                value: "",
                option: t(
                  "createAsset.placeholders.opticalConditionPlaceholder"
                ),
              },
              {
                value: 2,
                option: t("assets.opticalCondition.very_good"),
              },
              { value: 3, option: t("assets.opticalCondition.good") },
              { value: 4, option: t("assets.opticalCondition.used") },
              { value: 5, option: t("assets.opticalCondition.bad") },
              { value: 6, option: t("assets.opticalCondition.very_bad") },
              { value: 7, option: t("assets.opticalCondition.new") },
            ]}
          />
          {/* </div> */}

          <InputField
            name="commission"
            value={newAsset.commission}
            onChange={handleChange}
            label={t("attachments.fields.commission")}
            placeholder={t("attachments.placeholders.commission")}
            explanation={t("attachments.explanations.commission")}
            type="text"
          />

          <InputField
            name="available_from"
            type="date"
            value={newAsset.attachment_available}
            onChange={handleChange}
            label={t("attachments.fields.availableFrom")}
            placeholder={t("attachments.placeholders.availableFrom")}
            explanation={t("attachments.explanations.availableFrom")}
          />
        </div>

        {/* Row 5: Warehouse + Address */}
        <div className="grid grid-cols-1 sm:grid-cols-5 gap-2 mt-2">
          {Array.isArray(warehouses) && warehouses?.length > 0 && (
            <SelectField
              name="warehouse"
              value={selectedWarehouse?.id || warehouseLocationId || ""}
              onChange={handleWarehouseChange}
              label={t("createAsset.placeholders.warehouseLabel")}
              menus={[
                { value: "", option: "Select Warehouse" },
                ...warehouses.map((w) => ({ value: w.id, option: w.name })),
              ]}
            />
          )}

          <InputField
            name="dealer_street"
            value={newAsset.dealer_street}
            maxLength={20}
            onChange={handleChange}
            label={t("createAsset.placeholders.street")}
            placeholder={t("createAsset.placeholders.streetPlaceholder")}
            required
            explanation={t("createAsset.placeholders.streetExplanation")}
          />

          <InputField
            name="dealer_city"
            value={newAsset.dealer_city}
            maxLength={50}
            onChange={handleChange}
            label={t("createAsset.placeholders.city")}
            explanation={t("createAsset.placeholders.cityExplanation")}
            placeholder={t("createAsset.placeholders.cityPlaceholder")}
            required
          />

          <InputField
            name="dealer_zip"
            value={newAsset.dealer_zip}
            type="number"
            onChange={handleChange}
            label={t("createAsset.placeholders.zipCode")}
            explanation={t("createAsset.placeholders.zipCodePlaceholder")}
            placeholder={t("createAsset.placeholders.zipCodeExplanation")}
            maxLength={7}
            required
          />

          <InputField
            name="dealer_country"
            required
            value={newAsset.dealer_country}
            maxLength={50}
            onChange={handleChange}
            label={t("createAsset.placeholders.country")}
            explanation={t("createAsset.placeholders.countryExplanation")}
            placeholder={t("createAsset.placeholders.countryPlaceholder")}
          />
        </div>

        {/* Row 6: Additional Description */}
        <div className="mt-2">
          <TextAreaFielD
            name="description"
            value={newAsset.description}
            onChange={handleChange}
            label={t("createAsset.placeholders.additionalDescription")}
            placeholder={t(
              "createAsset.placeholders.additionalDescriptionPlaceholder"
            )}
          />
        </div>
      </div>

      {/* Media Section */}
      <div className="bg-white p-4 shadow-md mt-4">
        <h2 className="text-xl font-medium mb-3 text-gray-800">
          {t("assetPageHeadings.media")}
        </h2>

        {/* Selected Files Preview */}
        {selectedFiles?.length > 0 && (
          <div className="space-y-2 mt-2">
            <h6>Selected Media</h6>
            <ul className="space-y-1 flex flex-col gap-3">
              {Array.from(selectedFiles).map((file, index) => (
                <li key={index} className="flex items-center gap-4">
                  {file.type.startsWith("image/") && (
                    <img
                      className="h-10 w-10"
                      alt={`asset ${index}`}
                      src={URL.createObjectURL(file)}
                    />
                  )}
                  <a
                    href={URL.createObjectURL(file)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 text-sm font-semibold underline ml-2"
                  >
                    {file.name}
                  </a>
                  <div
                    onClick={() => handleRemoveFile(index)}
                    className="cursor-pointer"
                  >
                    <X className="h-5 w-5" />
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Uploaded Files */}
        {assetAttachments?.length > 0 && (
          <div className="flex flex-col gap-2 mt-4">
            <h6>Uploaded Media</h6>
            <div className="flex flex-col gap-3">
              {assetAttachments.map((attachment, index) => (
                <div key={index} className="flex items-center gap-2">
                  {attachment?.image ? (
                    <>
                      <img
                        className="h-10 w-10"
                        src={getAttachmentThumbUrl(attachment)}
                        alt="asset"
                      />
                      <a
                        href={getAttachmentLargeUrl(attachment)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 text-sm font-semibold underline ml-2"
                      >
                        {formatAttachment(getAttachmentLargeUrl(attachment))}
                      </a>
                    </>
                  ) : (
                    <a
                      href={getAttachmentDocumentUrl(attachment)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 text-sm font-semibold underline ml-2"
                    >
                      {formatAttachment(getAttachmentDocumentUrl(attachment))}
                    </a>
                  )}
                  <div
                    onClick={() => handleDeleteAttachment(attachment?.id)}
                    className="cursor-pointer"
                  >
                    <X className="h-5 w-5" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* File Upload */}
        <div className="my-4">
          <div className="relative">
            <input
              type="file"
              multiple
              onChange={handleFileChange}
              accept="image/*, .xlsx, .xls, .doc, .docx, .pdf"
              className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
              id="attachment-upload"
            />
            <label
              htmlFor="attachment-upload"
              className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 hover:border-gray-400"
            >
              <div className="flex flex-col items-center justify-center pt-5 pb-6">
                <div className="flex items-center space-x-2 mb-2">
                  <Upload className="w-6 h-6 text-gray-400" />
                  <ImagePlus className="w-6 h-6 text-gray-400" />
                </div>
                <p className="mb-2 text-sm text-gray-500">
                  <span className="font-semibold">
                    {t("assetPageHeadings.clickToUpload")}
                  </span>
                </p>
                <p className="text-xs text-gray-400">
                  {t("assetPageHeadings.fileSupported")}
                </p>
              </div>
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default Attachments;
